"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (newFn, rest) {
  return function () {
    var newResult = newFn.apply(undefined, arguments);
    if (newResult !== undefined && newResult !== null) {
      return newResult;
    }

    return rest.apply(undefined, arguments);
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-convert/lib/util/accumulateFunction.js
// module id = 458
// module chunks = 0